import ReactApexChart from 'react-apexcharts';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import useSupplierStatus from './hooks/useSupplierStatus';

const SupplierStatusSkeleton = () => (
    <Card className="h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '40%', height: '24px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '280px' }} />
        </CardBody>
    </Card>
);

const SupplierStatus = ({
    t,
}) => {
    const {
        segments,
        total,
        isLoading,
        isFetching,
        isError,
    } = useSupplierStatus({ t });

    if (isLoading || isFetching) {
        return <SupplierStatusSkeleton />;
    }

    if (isError || !segments?.length) {
        return null;
    }

    const series = segments.map((segment) => segment.value);
    const labels = segments.map((segment) => segment.label);
    const colors = segments.map((segment) => segment.color);
    const isSeriesEmpty = series.every((value) => value === 0);

    const chartOptions = {
        labels: isSeriesEmpty ? [t('No Data')] : labels,
        colors: isSeriesEmpty ? ['#e0e0e0'] : colors,
        chart: {
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#828282',
                            offsetY: -4,
                        },
                        value: {
                            show: true,
                            fontSize: '22px',
                            fontWeight: 700,
                            color: '#1D1D1D',
                            offsetY: 8,
                            formatter: (val) => val,
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            label: t('Total'),
                            fontSize: '14px',
                            fontWeight: 500,
                            color: '#828282',
                            formatter: () => (isSeriesEmpty ? '0' : String(total)),
                        },
                    },
                },
            },
        },
        dataLabels: {
            enabled: !isSeriesEmpty,
            dropShadow: {
                enabled: false,
            },
            formatter: (val) => `${Math.round(val)}%`,
        },
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            markers: {
                width: 10,
                height: 10,
                radius: 10,
            },
        },
        tooltip: {
            enabled: true,
            y: {
                formatter: (val) => val,
            },
        },
        stroke: {
            width: 0,
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    chart: {
                        height: 280,
                    },
                },
            },
        ],
    };

    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardTitle tag="h6" className="mb-4">
                    {t('Supplier Status')}
                </CardTitle>

                <div className="apex-charts">
                    <ReactApexChart
                        options={chartOptions}
                        series={isSeriesEmpty ? [1] : series}
                        type="donut"
                        height="320"
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(SupplierStatus);
